import * as io from "socket.io-client";
import $ from "jquery";

const telemetryIP = process.env.REACT_APP_TELEMETRY_IP;
const socketPort = process.env.REACT_APP_SOCKET_PORT;

const serverIP = process.env.REACT_APP_SERVER_IP;
const backendPort = process.env.REACT_APP_BACKEND_PORT;

let socket = null;

function connectSocket(authToken, carID, sessionID, eventID, str, callback) {
    socket = io.connect(telemetryIP + ":" + socketPort, {
        transports: ['websocket'],
        query: {token: authToken, identifier: str},
    }).on("connect", function () {
        callback("[API.JS][SOCKET] Connected!", null);
    });
    socket.on("reconnect", function (attempts) {
        console.log('[API.JS][SOCKET] Reconnected after ' + attempts + ' attempts.');
        if (carID) {
            socket.emit("device-stream-subscribal", {carId: parseInt(carID), eventId: parseInt(eventID)});
            callback("[API.JS] RE-Subscribed car to server...", null);
        }
        if (sessionID) {
            socket.emit('event-session-stream-subscribal', {sessionId: parseInt(sessionID), eventId: parseInt(eventID)}, (answer) => {
                callback("[API.JS] RE-Subscribed dash to server...", answer);
            });
        }
    });

    // TESTING PURPOSES
    socket.on('connect_error', function (data) {
        console.log('WS socket connect error!');
    });
    socket.on('connect_timeout', function (data) {
        console.log('WS socket connect timeout!');
    });
    socket.on('error', function (err) {
        console.error('WS socket error!');
        console.error(err);
    });
    socket.on('disconnect', function (data) {
        console.log('WS socket disconnected!');
    });
}

function forceReconnect(carID, sessionID, eventID, callback) {
    socket.on("reconnect", function (attempts) {
        console.log('[API.JS][SOCKET] Reconnected after ' + attempts + ' attempts.');
        if (carID) {
            socket.emit("device-stream-subscribal", {carId: parseInt(carID), eventId: parseInt(eventID)});
            callback("[API.JS] RE-Subscribed car to server...");
        }
        if (sessionID) {
            socket.emit('event-session-stream-subscribal', {sessionId: parseInt(sessionID), eventId: parseInt(eventID)}, (answer) => {
                callback("[API.JS] RE-Subscribed dash to server...", answer);
            });
        }
    });
}

function closeSocket() {
    socket.close();
    console.log("[API.JS][SOCKET] Closed!");
}

function subscribeCarToServer(eventID, carID, cb) {
    socket.emit("device-stream-subscribal", {carId: parseInt(carID), eventId: parseInt(eventID)});
    console.log("[API.JS] Subscribed car to server...");
    cb(null, {carId: parseInt(carID), eventId: parseInt(eventID)});
}

function subscribeDashToServer(eventID, sessionID, cb) {
    socket.emit('event-session-stream-subscribal', {eventId: parseInt(eventID), sessionId: parseInt(sessionID)}, (correctEvent, correctSession) => {
        cb("[API.JS] RE-Subscribed dash to server...", correctEvent, correctSession);
    });
}

function subscribeToTelemetry(slot, newSlot, disconnect, cb) {
    if (!disconnect) {
        if (!slot) {
            console.log("[API.JS][TELEMETRY] Connecting:", newSlot);
            socket.on(newSlot, function (value) {
                cb(null, value.dat);
            });
        } else {
            socket.off(slot);
            console.log("[API.JS][TELEMETRY] Disconnecting:", slot, "Connecting:", newSlot);
            socket.on(newSlot, function (value) {
                cb(null, value.dat);
            });
        }
    } else {
        console.log("[API.JS][TELEMETRY] Disconnecting:", slot);
        socket.off(slot);
    }
}

function subscribeToMapInfo(eventID, diconnect, cb) {
    if (!diconnect) {
        console.log("[API.JS][MAP INFO] Connecting: event_" + eventID + "-map-info ...");
        socket.on('event_' + eventID + '-map-info', function (value) {
            cb(null, value.crs);
        });
    } else {
        console.log("[API.JS][MAP INFO] Disconnected:", "event_" + eventID + "-map-info");
        socket.off("event_" + eventID + "-map-info");
    }
}

function subscribeToStandingsInfo(eventID, disconnect, cb) {
    if (!disconnect) {
        console.log("[API.JS][STANDINGS INFO] Connecting: event_" + eventID + "-standings-info ...");
        socket.on('event_' + eventID + '-standings-info', function (value) {
            cb(null, value);
        });
    } else {
        socket.off('event_' + eventID + '-standings-info');
        console.log("[API.JS][STANDINGS INFO] Disconnecting:", 'event_' + eventID + '-standings-info');
    }
}

function subscribeToLapInfo(slot, newSlot, disconnect, cb) {
    if (!disconnect) {
        if (!slot) {
            console.log("[API.JS][LAP INFO] Connecting", "car_" + newSlot + "-lap-info");
            socket.on("car_" + newSlot + "-lap-info", function (value) {
                cb(null, value);
            });
        } else {
            socket.off("car_" + slot + "-lap-info");
            console.log("[API.JS][LAP INFO] Disconnecting:", "car_" + slot + "-lap-info", "| Connecting:", "car_" + newSlot + "-lap-info");
            socket.on("car_" + newSlot + "-lap-info", function (value) {
                cb(null, value);
            });
        }
    } else {
        console.log("[API.JS][LAP INFO] Disconnecting:", "car_" + slot + "-lap-info");
        socket.off("car_" + slot + "-lap-info");
    }
}

function subscribeOrgCommands(eventID, sessionID, disconnect, cb) {
    if (!disconnect) {
        console.log("[API.JS][ORG COMMANDS LISTENER] Connecting: event_" + eventID + "-session_" + sessionID + "-org-notify ...");
        socket.on("event_" + eventID + "-session_" + sessionID + "-org-notify", function (value) {
            cb(null, value);
        });
    } else {
        socket.off("event_" + eventID + "-session_" + sessionID + "-org-notify");
        console.log("[API.JS][ORG COMMANDS LISTENER] Disconnecting:", "event_" + eventID + "-session_" + sessionID + "-org-notify");
    }
}

function subscribeToPitInfo(eventID, diconnect, cb) {
    if (!diconnect) {
        console.log("[API.JS][PIT INFO] Connecting: event_" + eventID + '-pit-info...');
        socket.on('event_' + eventID + '-pit-info', function (value) {
            cb(null, value.pts);
        });
    } else {
        console.log("[API.JS][PIT INFO] Disconnected:", "event_" + eventID + '-pit-info');
        socket.off("event_" + eventID + '-pit-info');
    }
}

function subscribeToDriverChangeInfo(eventID, diconnect, cb) {
    if (!diconnect) {
        console.log("[API.JS][DRIVER CHANGE] Connecting: event_" + eventID + '-driver-change-notify...');
        socket.on('event_' + eventID + '-driver-change-notify', function (value) {
            cb(null, value);
        });
    } else {
        console.log("[API.JS][DRIVER CHANGE] Disconnected:", "event_" + eventID + '-driver-change-notify');
        socket.off("event_" + eventID + '-driver-change-notify');
    }
}

function subscribeNotifyDriverChange(driverID, carID, sessionID, eventID, event_device_registry_id, callback) {
    socket.emit("session-driver-manual-changelog-notify", {
        eventId: parseInt(eventID),
        sessionId: parseInt(sessionID),
        carId: parseInt(carID),
        driverId: parseInt(driverID),
        edrId: parseInt(event_device_registry_id),
    });
    callback("Notified driver change, driver ID: " + driverID);
}

function subscribeToDiagnosticInfo(slot, newSlot, disconnect, cb) {
    if (!disconnect) {
        if (!slot) {
            console.log("[API.JS][DIAGNOSTIC] Connecting:", newSlot);
            socket.on("car_" + newSlot + "-diagnosis-data", function (value) {
                cb(null, value.dat);
            });
        } else {
            socket.off(slot);
            console.log("[API.JS][DIAGNOSTIC] Disconnecting:", slot, "Connecting:", newSlot);
            socket.on("car_" + newSlot + "-diagnosis-data", function (value) {
                cb(null, value.dat);
            });
        }
    } else {
        console.log("[API.JS][DIAGNOSTIC] Disconnecting:", slot);
        socket.off(slot);
    }
}

function subscribeToDriverReply(eventID, sessionID, disconnect, cb) {
    if (!disconnect) {
        console.log("[API.JS][DRIVER REPLY] Connecting:", "event_" + eventID + "-session_" + sessionID + "-driver-direct-message-notify");
        socket.on("event_" + eventID + "-session_" + sessionID + "-driver-direct-message-notify", function (value) {
            cb(null, value);
        });
    } else {
        console.log("[API.JS][DRIVER REPLY] Disconnecting:", "event_" + eventID + "-session_" + sessionID + "-driver-direct-message-notify");
        socket.off("event_" + eventID + "-session_" + sessionID + "-driver-direct-message-notify");
    }
}

function subscribeToOrgMessage(eventID, sessionID, disconnect, cb) {
    if (!disconnect) {
        console.log("[API.JS][ORG MESSAGE] Connecting:", "event_" + eventID + "-session_" + sessionID + "-org-direct-message-notify");
        socket.on("event_" + eventID + "-session_" + sessionID + "-org-direct-message-notify", function (value) {
            cb(null, value);
        });
    } else {
        console.log("[API.JS][ORG MESSAGE] Disconnecting:", "event_" + eventID + "-session_" + sessionID + "-org-direct-message-notify");
        socket.off("event_" + eventID + "-session_" + sessionID + "-org-direct-message-notify");
    }
}

function subscribeSessionStatus(eventID, disconnect, cb) {
    if (!disconnect) {
        console.log("[API.JS][SESSION STATUS] Connecting:", "event_" + eventID + "-flags-info");
        socket.on('event_' + eventID + '-flags-info', function (value) {
            cb(null, value);
        });
    } else {
        console.log("[API.JS][SESSION STATUS] Disconnecting:", "event_" + eventID + "-flags-info");
        socket.off("event_" + eventID + "-flags-info");
    }
}

function subscribeFlagWarnings(eventID, sessionID, disconnect, cb) {
    if (!disconnect) {
        console.log("[API.JS][FLAG WARNING] Connecting:", 'event_' + eventID + '-session_' + sessionID + '-org-flag-notify');
        socket.on('event_' + eventID + '-session_' + sessionID + '-org-flag-notify', function (value) {
            cb(null, value);
        });
    } else {
        console.log("[API.JS][FLAG WARNING] Disconnecting:", 'event_' + eventID + '-session_' + sessionID + '-org-flag-notify');
        socket.off('event_' + eventID + '-session_' + sessionID + '-org-flag-notify');
    }
}

function subscribeOrgMessageToGarage(eventID, sessionID, disconnect, cb) {
    if (!disconnect) {
        console.log("[API.JS][ORG MSG TO GAR] Connecting:", 'event_' + eventID + '-session_' + sessionID + '-org-message-garage');
        socket.on('event_' + eventID + '-session_' + sessionID + '-org-message-garage', function (value) {
            cb(null, value);
        });
    } else {
        console.log("[API.JS][ORG MSG TO GAR] Disconnecting:", 'event_' + eventID + '-session_' + sessionID + '-org-message-garage');
        socket.off('event_' + eventID + '-session_' + sessionID + '-org-message-garage');
    }
}

function confirmIdentity(authToken, userID, eventID, callback) {
    $.ajax({
        type: 'POST',
        url: serverIP + ':' + backendPort + '/dashboard/confirmAction',
        dataType: "json",
        headers: {
            'authorization': authToken
        },
        data: {
            userID: userID,
            eventID: eventID,
        },
        success: function (data) {
            if (data.confirmed) {
                console.log("SUPER ADMIN/ORG USER/EVENT ORGANIZER: Confirmed.");
            } else {
                console.error("SUPER ADMIN/ORG USER/EVENT ORGANIZER: Not confirmed.");
            }
            callback(data.confirmed);
        },
        error: function (err) {
            if (err) {
                console.log('Error CONFIRMING IDENTITY', err);
            }
            callback(false);
        }
    });
}

function confirmSession(authToken, eventID, sessionID, callback) {
    $.ajax({
        type: 'POST',
        url: serverIP + ':' + backendPort + '/dashboard/confirmSession',
        dataType: "json",
        headers: {
            'authorization': authToken,
        },
        data: {
            eventID: eventID,
            sessionID: sessionID,
        },
        success: function (data) {
            if (data.closed) {
                console.log("This session is closed already.");
            } else {
                console.log("This session is active.");
            }
            callback(data.closed);
        },
        error: function (err) {
            if (err) {
                console.error('Error CONFIRMING SESSION ACTIVE STATUS', err);
            }
            callback(false);
        }
    });
}

function subscribeClock(callback) {
    if (callback === null) {
        socket.off('server-time-report');
    } else {
        socket.on('server-time-report', function (obj) {
            if (obj && obj.tim > 0) {
                callback(obj);
            } else {
                callback({
                    cli: null,
                    tim: new Date().getTime()
                });
            }
        });
    }
}

export {
    subscribeToTelemetry,
    subscribeToMapInfo,
    subscribeToLapInfo,
    subscribeCarToServer,
    subscribeDashToServer,
    subscribeToStandingsInfo,
    subscribeOrgCommands,
    subscribeToPitInfo,
    connectSocket,
    forceReconnect,
    closeSocket,
    subscribeToDriverChangeInfo,
    subscribeNotifyDriverChange,
    subscribeToDiagnosticInfo,
    confirmIdentity,
    confirmSession,
    subscribeToDriverReply,
    subscribeToOrgMessage,
    subscribeSessionStatus,
    subscribeFlagWarnings,
    subscribeOrgMessageToGarage,
    subscribeClock,
};
